<template>
    <!-- 审核界面 -->
    <el-drawer :title="title" :visible.sync="formVisible" @click="closeDialog" :size="500" :wrapperClosable="false"
        :modal='false' :destroy-on-close='true'>
        <div class="d_three">
            <!-- <div class="dh_a">审批流程</div> -->
            <div>
                <el-timeline v-if="processList.length != 0">
                    <el-timeline-item v-for="(item, index) in processList" :key="index" :timestamp="item.approvalTime"
                        :color="item.action === 1 ? '#16fc35' : '#6b6b6b'" placement="top">
                        <el-card>
                            <h5 v-if="item.nodeName != '开始' && item.nodeName != '结束' && item.action">{{ item.nodeName
                                }}：
                                {{ item.action === 1 ? '通过' : '不通过' }}</h5>
                            <h5 v-else>{{ item.nodeName }}</h5>
                            <div>{{ item.message }}</div>
                            <p style="text-align:right" v-if="item.nodeName != '结束'">—{{ item.actorName }}</p>
                        </el-card>
                    </el-timeline-item>
                </el-timeline>
                <el-empty v-else description="暂无审批记录"></el-empty>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import {
    GetNodeList,
} from '@/api/workFlowApi.js'
export default {
    name: 'ApprovalRecord',
    data() {
        return {
            title: '详情',
            saveloading: false,
            formVisible: false,
            processList: [],
            activeNum: 0,
            type: 1,


        };
    },
    computed: {},
    watch: {},
    methods: {
        // 显示
        editShow(row) {
            this.title = '【' + row.title + '】审批流程记录';
            this.formVisible = true;
            this.approvalProcess(row)
        },


        // 流程步骤
        approvalProcess(row) {
            let parameter = {
                instanceID: row.instanceID,
            };
            GetNodeList(parameter)
                .then((res) => {
                    if (res.code == 1) {
                        this.activeNum = 0
                        this.processList = res.data.map(item => {
                            if (item.action) {
                                this.activeNum++
                            }
                            return item
                        })
                    } else {
                        this.$message.error('请先送审');
                        return
                    }
                })
                .catch((err) => {
                    this.$message.error('加载失败，请稍后再试！');
                });
        },
        // 关闭
        closeDialog() {
            this.formVisible = false;
        },
    },
    created() { },
    mounted() { },
};
</script>
<style scoped>
/deep/ .el-drawer__body {
    background: #f1f1f1;
}

/deep/ .el-drawer__header {
    margin-bottom: 16px;
}

.d_one {
    margin-top: 1px;
    margin-bottom: 15px;
    min-height: 100px;
    background: #fff;
}

.do_a {
    padding: 15px 15px;
    font-size: 12px;
    color: #8d8d8d;
}

.do_b {
    padding: 5px 15px;
    font-size: 18px;
    font-weight: 600;
}

.d_two {
    margin-bottom: 15px;
    min-height: 300px;
    background: #fff;
    padding: 15px 15px;
}

.dt_a {
    font-size: 12px;
    color: #8d8d8d;
}

.dt_b {
    font-size: 14px;
    color: #000000;
    padding: 5px 0px 20px 0px;
}

.dt_b_1 {
    color: #16fc35;
    text-decoration: underline;
    cursor: pointer;
}

.d_three {
    margin-bottom: 15px;
    min-height: 200px;
    background: #fff;
    padding: 15px 15px;
}

.dh_a {
    font-size: 16px;
    color: #6b6b6b;
}

.d_four {
    position: fixed;
    bottom: 0px;
    right: 0px;
    width: 600px;
    height: 50px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 20;
}

.d_five {
    margin-bottom: 15px;
    min-height: 100px;
    background: #fff;
    padding: 15px 15px;
}

.d_six {
    display: flex;
    margin-bottom: 60px;
    background: #fff;
    padding: 15px 15px;
}
</style>